import {
  LOAD_EDITOR_UI_BOOK_PROPERTIES,
  CHANGE_BOOK_BACKGROUND_IMAGE,
  CHANGE_BOOK_BACKGROUND_TYPE,
  LOAD_BOOK_BACKGROUND_TYPE } from '../../action-types/ui/bookProperties';


export const loadEditorBookProperties = context => ({
  type: LOAD_EDITOR_UI_BOOK_PROPERTIES,
  context,
});

export const changeBookBackgroundImage = (image, fullImage, size) => ({
  type: CHANGE_BOOK_BACKGROUND_IMAGE,
  image,
  fullImage,
  size,
});

export const changeBookBackgroundType = backgroundType => ({
  type: CHANGE_BOOK_BACKGROUND_TYPE,
  backgroundType,
});

export const loadBookBackgroundType = bookProperties => ({
  type: LOAD_BOOK_BACKGROUND_TYPE,
  bookProperties,
});




// WEBPACK FOOTER //
// ./src/redux/actions/ui/bookProperties.js